import Vue from "vue";
import ConfigurationPlugin from "@/config";
import Config from "@/secrets";
import { Services } from "@/api";
import { parseSensorLang } from "@/views/viz/sensor-strings";

import i18n from "./embed-i18n";
import { applyEmbedLocale } from "./embed-locale";
import { applyEmbedFrameClass } from "./embed-frame";

import "./embed.scss";
import "@/icomoon/style.css";

const AssetsPlugin = {
    install(vue: typeof Vue) {
        const loader = require.context("@/assets/", true, /\.(?:svg|png)$/);
        vue.prototype.$loadAsset = (path: string) => loader("./" + path);
    },
};

export interface EmbedBootstrapOptions {
    useFrameLayout?: boolean;
    installFilters?: () => void;
    installMapbox?: () => void;
}

export function bootstrapEmbed(options: EmbedBootstrapOptions = {}): void {
    options.installMapbox?.();
    if (options.useFrameLayout) {
        applyEmbedFrameClass();
    }
    options.installFilters?.();

    applyEmbedLocale(i18n, parseSensorLang(new URLSearchParams(window.location.search).get("lang")));

    const services = new Services();
    Object.defineProperty(Vue.prototype, "$services", {
        get(this: Vue) {
            return services;
        },
    });

    Vue.use(ConfigurationPlugin, Config);
    Vue.use(AssetsPlugin);
    Vue.config.productionTip = false;
}

export { i18n };
